import i18n from "@/i18n";

export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/;

export const phoneRegex = /^\+1 \d{3} \d{3} \d{4}$/;
export const zipRegex = /^\d{5}(-\d{4})?$/;
export const stateRegex = /^(AL|AK|AZ|AR|CA|CO|CT|DE|FL|GA|HI|ID|IL|IN|IA|KS|KY|LA|ME|MD|MA|MI|MN|MS|MO|MT|NE|NV|NH|NJ|NM|NY|NC|ND|OH|OK|OR|PA|RI|SC|SD|TN|TX|UT|VT|VA|WA|WV|WI|WY|DC)$/
export const emailRegex = /^[^\s@]{1,64}@[^\s@]{1,255}\.[^\s@]{2,24}$/

// Date pattern regex
export const datePatterns = {
  date: "\\d{2}/\\d{2}/\\d{4}",
  dateTime: "\\d{2}/\\d{2}/\\d{4}, \\d{2}:\\d{2}",
  time: "\\d{2}:\\d{2}",
};

// Reactive validation messages that update when locale changes
// These functions are called at validation time, ensuring translations are always current
export const validationMessages = {
  onlyAlphabets: (field) => {
    // Force re-evaluation by accessing locale value
    const currentLocale = i18n.global.locale.value;
    return i18n.global.t('validation.validationMessages.onlyAlphabets', { field }, { locale: currentLocale });
  },
  required: (field) => {
    const currentLocale = i18n.global.locale.value;
    return i18n.global.t('validation.validationMessages.required', { field }, { locale: currentLocale });
  },
  email: (field) => {
    const currentLocale = i18n.global.locale.value;
    return i18n.global.t('validation.validationMessages.email', { field }, { locale: currentLocale });
  },
  minLength: (field, min) => {
    const currentLocale = i18n.global.locale.value;
    return i18n.global.t('validation.validationMessages.minLength', { field, min }, { locale: currentLocale });
  },
  maxLength: (field, max) => {
    const currentLocale = i18n.global.locale.value;
    return i18n.global.t('validation.validationMessages.maxLength', { field, max }, { locale: currentLocale });
  },
  minLengthDigits: (field, min) => {
    const currentLocale = i18n.global.locale.value;
    return i18n.global.t('validation.validationMessages.minLengthDigits', { field, min }, { locale: currentLocale });
  },
  maxLengthDigits: (field, max) => {
    const currentLocale = i18n.global.locale.value;
    return i18n.global.t('validation.validationMessages.maxLengthDigits', { field, max }, { locale: currentLocale });
  },
  password: (field) => {
    const currentLocale = i18n.global.locale.value;
    return i18n.global.t('validation.validationMessages.password', { field }, { locale: currentLocale });
  },
  passwordMatch: (field) => {
    const currentLocale = i18n.global.locale.value;
    return i18n.global.t('validation.validationMessages.passwordMatch', { field }, { locale: currentLocale });
  },
  passwordComplexity: () => {
    const currentLocale = i18n.global.locale.value;
    return i18n.global.t('validation.validationMessages.passwordComplexity', {}, { locale: currentLocale });
  },
  format: (fieldName) => {
    const currentLocale = i18n.global.locale.value;
    return i18n.global.t('validation.validationMessages.format', { fieldName }, { locale: currentLocale });
  },
  emailMatch: (fieldName, confirmFieldName) => {
    const formattedFieldName = fieldName.charAt(0).toUpperCase() + fieldName.slice(1).toLowerCase();
    const formattedConfirmFieldName = confirmFieldName.toLowerCase();
    const currentLocale = i18n.global.locale.value;
    return i18n.global.t('validation.validationMessages.emailMatch', { 
      fieldName: formattedFieldName, 
      confirmFieldName: formattedConfirmFieldName 
    }, { locale: currentLocale });
  },
  phone: (field) => {
    const currentLocale = i18n.global.locale.value;
    return i18n.global.t('validation.validationMessages.phone', { field }, { locale: currentLocale });
  },
  zipCode: (field) => {
    const currentLocale = i18n.global.locale.value;
    return i18n.global.t('validation.validationMessages.zipCode', { field }, { locale: currentLocale });
  },
  addressState: (field) => {
    const currentLocale = i18n.global.locale.value;
    return i18n.global.t('validation.validationMessages.addressState', { field }, { locale: currentLocale });
  },
  atLeast18: () => {
    const currentLocale = i18n.global.locale.value;
    return i18n.global.t('validation.validationMessages.atLeast18', {}, { locale: currentLocale });
  },
};

// Phone validation helper functions
